import React, { useState, useEffect } from 'react'
import "../../assets/style/eegisterProvider.css"
import { TextField, Button, FormControl, InputLabel, Select, MenuItem, Typography, Box } from '@mui/material';
import components from '../../components';
import FundUnitsTable from '../../components/Table/FundUnitsTable';
import ApiCall from '../../utils/Api';
import { toast } from 'react-toastify';

const FundUnits = () => {
  const [BackDropState, setBackDropState] = useState(false);
  const [fundUnits, setFundUnits] = useState([]);
  const [filteredUnits, setFilteredUnits] = useState([]);
  const [loading, setLoading] = useState(false);

  // Filter states
  const [institution, setInstitution] = useState('');
  const [instrument, setInstrument] = useState('');

  // Get all available fund units
  const fetchFundUnits = async () => {
    try {
      setLoading(true);
      setBackDropState(true);
      
      // Fetch all data units created by providers
      const response = await ApiCall.SECURE_API.get('/dataunit/getAllDataunit');
      
      if (response.data.success) {
        const units = response.data.data || [];
        setFundUnits(units);
        setFilteredUnits(units);
      } else {
        toast.error(response.data.message || 'Failed to load fund units');
      }
    } catch (error) {
      console.error('Error fetching fund units:', error);
      toast.error('Failed to load fund units');
    } finally {
      setLoading(false);
      setBackDropState(false);
    }
  };

  // Filter fund units based on selected criteria
  const applyFilters = () => {
    let filtered = [...fundUnits];

    if (institution) {
      filtered = filtered.filter(unit => 
        unit.providerData?.institutionName && unit.providerData.institutionName.toLowerCase().includes(institution.toLowerCase())
      );
    }

    if (instrument) {
      filtered = filtered.filter(unit => 
        unit.instrument && unit.instrument.toLowerCase().includes(instrument.toLowerCase())
      );
    }

    setFilteredUnits(filtered);
  };

  // Clear all filters
  const clearFilters = () => {
    setInstitution('');
    setInstrument('');
    setFilteredUnits(fundUnits);
  };

  useEffect(() => {
    fetchFundUnits();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [institution, instrument, fundUnits]);

  return (
    <div style={{ 
      width: '100%', 
      minHeight: '100vh', 
      backgroundColor: '#f5f5f5',
      padding: '20px'
    }}>
      <div style={{ 
        maxWidth: '1400px', 
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
      }}>
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom
          sx={{ 
            fontSize: '28px',
            fontWeight: '600',
            color: '#333',
            marginBottom: '24px'
          }}
        >
          Tokenized Fund Units and Tiers
        </Typography>
        
        {/* Filter Section */}
        <Box sx={{ 
          display: 'flex', 
          gap: 3, 
          mb: 4, 
          flexWrap: 'wrap',
          alignItems: 'center',
          padding: '16px',
          backgroundColor: '#f8f9fa',
          borderRadius: '8px',
          border: '1px solid #e9ecef'
        }}>
          <FormControl sx={{ minWidth: 250 }}>
            <InputLabel>Select Institution</InputLabel>
            <Select
              value={institution}
              onChange={(e) => setInstitution(e.target.value)}
              label="Select Institution"
              sx={{ backgroundColor: 'white' }}
            >
              <MenuItem value="">
                <em>All Institutions</em>
              </MenuItem>
              {[...new Set(fundUnits.map(unit => unit.providerData?.institutionName).filter(Boolean))].map((name, index) => (
                <MenuItem key={index} value={name}>
                  {name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl sx={{ minWidth: 250 }}>
            <InputLabel>Select Instrument</InputLabel>
            <Select
              value={instrument}
              onChange={(e) => setInstrument(e.target.value)}
              label="Select Instrument"
              sx={{ backgroundColor: 'white' }}
            >
              <MenuItem value="">
                <em>All Instruments</em>
              </MenuItem>
              {[...new Set(fundUnits.map(unit => unit.instrument).filter(Boolean))].map((inst, index) => (
                <MenuItem key={index} value={inst}>
                  {inst}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button 
            variant="outlined" 
            onClick={clearFilters}
            sx={{ 
              height: '56px',
              minWidth: '120px',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            Clear Filters
          </Button>
        </Box>

        {/* Fund Units Table */}
        <FundUnitsTable 
          data={filteredUnits}
          loading={loading}
          onRefresh={fetchFundUnits}
        />

        {/* Loading Backdrop */}
        {BackDropState && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div style={{ color: 'white', fontSize: '18px' }}>Loading...</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FundUnits;
